import axios from 'axios'
const state = {}
import config from '@/../config'
const defaultErrorHandler = (error => Promise.reject(error.response))

const mutations = {}

const actions = {

    // LOGIN AND ME
    async LOGIN({
        commit
    }, payload) {
        let response = await axios.post(config.apiUrl + config.versoes[0] + '/auth/login', payload)
        return response.data
    },
    async GET_COMPANIES({
        commit
    }, payload) {
        let response = await axios.post(config.apiUrl + config.versoes[0] + '/auth/companies', payload)
        return response.data
    },
    async TEST_TOKEN({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[0] + '/auth/login', payload)
        return response.data
    },

    async ACCEPT_TOS({
        commit
    }, payload) {
        let response = await axios.patch(config.apiUrl + config.versoes[0] + '/usuarios/', payload)

        return response.data
    },

    async GET_ME({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[0] + '/profiles/me')
        return response.data
    }
}

export default {state, mutations, actions}



// WEBPACK FOOTER //
// ./src/store/modules/login.js